import { gql } from "@apollo/client";
export const AddUser = gql `
  mutation AddUser($input: AddUserInput!) {
    addUser(input: $input)
  }
`;
